import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";

import { useCart } from "../context/CartContext";

const Cart = () => {
  const { cartItems, updateQuantity, removeFromCart, cartTotal } = useCart();

  const formatPrice = (price) => {
    return `TZS ${Number(price).toLocaleString()}`;
};

  // Empty Cart
  if (cartItems.length === 0) {
    return (
      <main
        className="
        min-h-screen
        bg-gray-50
        flex
        items-center
        justify-center
        px-6
      "
      >
        <div
          className="
          bg-white
          rounded-3xl
          p-10
          text-center
          border
          border-gray-200
        "
        >
          <h1
            className="
            text-2xl
            font-bold
            text-gray-900
          "
          >
            Your Cart is Empty
          </h1>

          <p
            className="
            mt-3
            text-gray-600
          "
          >
            Add healthcare equipment to continue shopping.
          </p>

          <Link
            to="/shop"
            className="
              inline-block
              mt-6
              bg-green-600
              text-white
              px-8
              py-3
              rounded-xl
              hover:bg-green-700
              transition
            "
          >
            Browse Products
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main
      className="
      bg-gray-50
      min-h-screen
      py-12
    "
    >
      <div
        className="
        max-w-7xl
        mx-auto
        px-6
      "
      >
        <h1
          className="
          text-3xl
          font-bold
          text-gray-900
          mb-8
        "
        >
          Shopping Cart
        </h1>

        <div
          className="
          grid
          lg:grid-cols-3
          gap-8
        "
        >
          {/* Cart Items */}

          <div
            className="
            lg:col-span-2
            space-y-5
          "
          >
            {cartItems.map((item) => (
              <div
                key={item._id}
                className="
                  bg-white
                  rounded-2xl
                  border
                  border-gray-200
                  p-5
                  flex
                  flex-col
                  sm:flex-row
                  gap-5
                "
              >
                {/* Image */}

                <div
                  className="
                  w-full
                  sm:w-32
                  h-32
                  bg-gray-100
                  rounded-xl
                  flex
                  items-center
                  justify-center
                "
                >
                  <img
                    src={item.image?.asset?.url}
                    alt={item.name}
                    className="
                      w-full
                      h-full
                      object-contain
                    "
                  />
                </div>

                {/* Details */}

                <div
                  className="
                  flex-1
                "
                >
                  <h2
                    className="
                    text-lg
                    font-bold
                    text-gray-900
                  "
                  >
                    {item.name}
                  </h2>

                  <p
                    className="
                    text-sm
                    text-gray-500
                    mt-1
                  "
                  >
                    {item.category?.title}
                  </p>

                  <p
                    className="
                    mt-3
                    text-green-600
                    font-bold
                  "
                  >
                    {formatPrice(item.price)}
                  </p>

                  {/* Quantity */}

                  <div
                    className="
                    mt-4
                    flex
                    items-center
                    gap-3
                  "
                  >
                    <button
                      onClick={() => updateQuantity(item._id, item.quantity - 1)}
                      className="
                        p-2
                        border
                        rounded-lg
                        hover:bg-gray-100
                      "
                    >
                      <Minus size={16} />
                    </button>

                    <span
                      className="
                      font-semibold
                    "
                    >
                      {item.quantity}
                    </span>

                    <button
                      onClick={() => updateQuantity(item._id, item.quantity + 1)}
                      className="
                        p-2
                        border
                        rounded-lg
                        hover:bg-gray-100
                      "
                    >
                      <Plus size={16} />
                    </button>
                  </div>

                  <button
                    onClick={() => removeFromCart(item._id)}
                    className="
                      mt-4
                      flex
                      items-center
                      gap-2
                      text-red-500
                      hover:text-red-600
                    "
                  >
                    <Trash2 size={17} />
                    Remove
                  </button>
                </div>

                {/* Item Total */}

                <div
                  className="
                  font-bold
                  text-gray-900
                "
                >
                  {formatPrice(item.price * item.quantity)}
                </div>
              </div>
            ))}
          </div>

          {/* Summary */}

          <div
            className="
            bg-white
            rounded-2xl
            border
            border-gray-200
            p-6
            h-fit
          "
          >
            <h2
              className="
              text-xl
              font-bold
              text-gray-900
            "
            >
              Order Summary
            </h2>

            <div
              className="
              flex
              justify-between
              mt-6
              text-gray-600
            "
            >
              <span>Total</span>

              <span
                className="
                text-xl
                font-bold
                text-green-600
              "
              >
                {formatPrice(cartTotal)}
              </span>
            </div>

            <Link
              to="/checkout"
              className="
                block
                text-center
                mt-8
                bg-green-600
                text-white
                py-3
                rounded-xl
                font-semibold
                hover:bg-green-700
                transition
              "
            >
              Proceed To Checkout
            </Link>

            <Link
              to="/shop"
              className="
                block
                text-center
                mt-4
                text-green-600
                font-medium
              "
            >
              Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Cart;
